import {
  CosmosQueryFileSchema,
  CosmosQueryResponseSchema,
  DocSorterFileSchema,
} from "@api/generated/types.gen";

export type IndexingStatus = "PENDING" | "IN_PROGRESS" | "INDEXED" | "FAILED";

// Augmented file shape including the indexing readiness columns added by the
// semantic-search-readiness work. Once `pnpm update-api-client` has been run
// against a backend exposing the new fields, these will appear in the generated
// types and this augmentation can be deleted.
export type FileWithIndexing = DocSorterFileSchema & {
  is_indexed?: boolean;
  indexing_status?: IndexingStatus;
  indexed_at?: string | null;
};

export type CosmosQueryFileWithIndexing = CosmosQueryFileSchema & {
  indexing_status?: IndexingStatus;
  indexed_at?: string | null;
};

export type CosmosQueryResponseWithReadiness = CosmosQueryResponseSchema & {
  not_ready?: boolean;
  indexed_count?: number;
  total_count?: number;
};

export const isIndexingTerminal = (status: IndexingStatus | undefined): boolean =>
  status === "INDEXED" || status === "FAILED";

export const isFileSemanticSearchReady = (
  file: Pick<FileWithIndexing, "is_indexed" | "indexing_status">
): boolean => {
  if (file.indexing_status) return file.indexing_status === "INDEXED";
  return Boolean(file.is_indexed);
};
